export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/broker/tp',
		name: 'NbuBrokerTp',
		title: {
			single: 'NbuBrokerTp',
			plural: 'NbuBrokerTps'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "2",
				"code": null,
				"name": "Перестраховий брокер",
				"caption": "Перестраховий брокер",
				"isBlocked": false
			},
			{
				"id": "1",
				"code": null,
				"name": "Страховий брокер",
				"caption": "Страховий брокер",
				"isBlocked": false
			},
			{
				"id": "3",
				"code": null,
				"name": "Страховий та перестраховий брокер",
				"caption": "Страховий та перестраховий брокер",
				"isBlocked": false
			}
		],
	},
}
